// extracted by mini-css-extract-plugin
export default {"container":"Counter_container__KYnKT","title":"Counter_title__bSfBg","subtitle":"Counter_subtitle__QYl+U","counterContainer":"Counter_counterContainer__yddcQ"};